import * as React from 'react';
import { useNavigate } from 'react-router-dom';

import { Loading } from 'components';
import { ROUTES } from 'consts';
import { useParamValues } from 'hooks/url.hook';
import { useFetchBuildingQuery } from 'store/apis';
import { useAppDispatch, useAppSelector } from 'store/store.hook';
import { selectCurrentUserInfo } from 'store/slices/auth.slice';
import { updateLayout } from 'store/slices/layout.slice';
import { DashboardCards } from './dashboard-cards';
import { DashboardPageContextProvider } from './dashboard-page.context';

interface DashboardPageProps {}

export const DashboardPage: React.FC<DashboardPageProps> = () => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const { orgSlug } = useAppSelector(selectCurrentUserInfo);

  const { buildingId: buildingIdStr } = useParamValues(['buildingId']);
  const buildingId = buildingIdStr ? Number(buildingIdStr) : null;

  const { data: building, isLoading: loading_building } = useFetchBuildingQuery({ orgSlug, id: buildingId as number });

  React.useEffect(() => {
    dispatch(updateLayout({ headerTitle: 'Dashboard' }));
  }, []);

  React.useEffect(() => {
    if (!loading_building && !building) {
      navigate(`/${orgSlug}/${ROUTES.DASHBOARD}`);
    }
  }, [building, loading_building]);

  if (loading_building) {
    return <Loading text="Building dashboard configuration..." height={400} />;
  }

  return buildingId ? (
    <DashboardPageContextProvider>
      <DashboardCards building={building} />
    </DashboardPageContextProvider>
  ) : null;
};
